<template>
  <b-overlay
    :show="overlay_show"
    rounded="sm"
    variant="dark"
    opacity="0.8"
    blur="2px"
    class="h-100"
  >
    <div class="container agora-video-call-container">
      <div class="agora-header">
        <b-container>
          <h2>{{ options.eventName }}</h2>
        </b-container>
      </div>

      <div class="agora-users-container h-100">
        <!-- {{ remoteUsers }}
      {{ remote_users_id }} -->

        <b-row class="h-100">
          <b-col :lg="this.display_user == true ? 10 : 12" class="h-100">
            <b-row class="h-100">
              <b-col lg="10" v-if="is_share_screen == true" class="p-0">
                <div class="user-tile" id="share-user">
                  <div id="share-player" class="player">
                    <p id="share-player-name" class="player-name"></p>
                  </div>
                </div>
              </b-col>
              <b-col :lg="this.is_share_screen == true ? 2 : 12" class="p-0">
                <div class="video-group" id="remote-playerlist">
                  <!-- <div
          class="user-tile"
          id="share-screen-user"
          style="grid-area: span 12 / span 12"
        >
          <div id="share-screen-player" class="player">
            <div class="player-sub-name"><span>SR</span></div>
           <p id="local-player-name" class="player-name"></p> 
          </div>
        </div> -->
                  <div
                    class="user-tile"
                    id="local-user"
                    style="grid-area: span 12 / span 12"
                  >
                    <div id="local-player" class="player">
                      <div class="player-sub-name">
                        <span>{{ local_user_char }}</span>
                      </div>
                      <p id="local-player-name" class="player-name">
                        {{ local_user_name }}
                      </p>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row></b-col
          >
          <b-col
            lg="2"
            class="h-100 p-0"
            :class="{
              'd-none':
                display_user == false || buttons_status.is_join == false,
              'd-block': display_user == true && buttons_status.is_join == true,
            }"
          >
            <b-card id="agora-users-card" class="h-100 m-0" title="Users">
              <b-list-group>
                <b-list-group-item
                  id="list-item-local"
                  class="d-flex justify-content-between align-items-center px-0"
                >
                  <p id="list-item-local-name" class="list-item-user-name"></p>
                  <span class="player-status"></span>
                </b-list-group-item>

                <b-list-group-item
                  v-for="user_id in remote_users_id"
                  :key="user_id"
                  :id="'list-item-remote-' + getUserNameAndId(user_id)[0]"
                  class="d-flex justify-content-between align-items-center px-0"
                >
                  <p
                    :id="
                      'list-item-remote-name-' + getUserNameAndId(user_id)[0]
                    "
                    class="list-item-user-name"
                  >
                    {{ getUserNameAndId(user_id)[1] }}
                  </p>
                  <span class="player-status"></span>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <!-- {{ remoteUsers }} -->
      <!-- {{ remote_users_id }} -->

      <!-- <div v-for="user in remoteUsers" :key="user.uid">
      {{ user.uid }} --- {{ user._video_muted_ }} -- {{ user._audio_muted_ }} ,
      {{ user.video_muted }}
    </div>
    <div class="users-container">
      <div
        class="user"
        :id="'user-' + index"
        v-for="(user, index) in users"
        :key="user"
      >
        {{ user }}
      </div>
    </div> -->

      <div class="agora-footer">
        <b-container>
          <b-row>
            <b-col class="mx-auto text-center p-0">
              <b-button-group class="btn-group-actions-agora">
                <b-button variant="agora-action" @click="clickMuteAudio">
                  <div v-if="!buttons_status.is_audio_muted">
                    <img src="@/assets/images/agora/audio.png" />
                    <span class="action-text"> Mute</span>
                  </div>
                  <div v-if="buttons_status.is_audio_muted">
                    <img src="@/assets/images/agora/audio-mute.png" />
                    <span class="action-text"> Unmute</span>
                  </div>
                </b-button>
                <b-button variant="agora-action" @click="clickMuteVideo">
                  <div v-if="!buttons_status.is_video_muted">
                    <img src="@/assets/images/agora/video.png" /><span
                      class="action-text"
                    >
                      Stop Video</span
                    >
                  </div>
                  <div v-if="buttons_status.is_video_muted">
                    <img src="@/assets/images/agora/video-mute.png" /><span
                      class="action-text"
                      >Start Video</span
                    >
                  </div>
                </b-button>
                <b-button
                  variant="agora-action"
                  @click="clickShareScreen"
                  :disabled="
                    buttons_status.is_join == false ||
                    (buttons_status.is_join == true && is_share_screen == true)
                  "
                >
                  <img src="@/assets/images/agora/share.png" /><span
                    class="action-text"
                    >Share screen
                  </span></b-button
                >
                <b-button
                  variant="agora-action"
                  @click="clickJoin"
                  :disabled="buttons_status.is_join == true"
                >
                  <img src="@/assets/images/agora/join.png" /><span
                    class="action-text"
                    >Join</span
                  ></b-button
                >
                <b-button
                  variant="agora-action"
                  @click="clickLeave"
                  :disabled="buttons_status.is_join == false"
                >
                  <img src="@/assets/images/agora/leave.png" /><span
                    class="action-text"
                    >Leave</span
                  ></b-button
                >
                <b-button
                  variant="agora-action"
                  :disabled="buttons_status.is_join == false"
                  @click="display_user = !display_user"
                >
                  <!-- <b-avatar
                square
                  badge="7"
                  badge-top
                  variant="primary"
                  badge-variant="dark"
                  :src="require('@/assets/images/agora/users.png')"
                ></b-avatar>
                <span
                  >Users</span
                > -->
                  <b-img :src="require('@/assets/images/agora/users.png')" />
                  <b-badge
                    variant="primary"
                    v-if="buttons_status.is_join == true"
                    >{{ remote_users_id.length + 1 }}</b-badge
                  >
                  <span class="action-text">Users</span>
                  <!--   <b-badge variant="primary" pill="true">4</b-badge> -->
                </b-button>
                <!-- <b-button variant="agora-action" @click="clickAddUser"
                >add
              </b-button>
              <b-button variant="agora-action" @click="clickDeleteUser"
                >remove
              </b-button> -->
              </b-button-group>
            </b-col>
          </b-row>
          <!---->
        </b-container>
      </div>
    </div>
  </b-overlay>
</template>


<script>
/** screenVideoTrack: null,
  audioTrack: null,
  screenAudioTrack: null */
import AgoraRTC from "agora-rtc-sdk-ng";
import $ from "jquery";
import axios from "axios";

var localTracks = {
  videoTrack: null,
  audioTrack: null,
};
let client = null;

let clientShare = null;
let shareTrack = null;

var localTrackState = {
  videoTrackMuted: false,
  audioTrackMuted: false,
};
export default {
  name: "AgoraIndex",
  components: {},
  data() {
    return {
      overlay_show: false,
      options: {
        // Pass your App ID here.
        appId: "e74e2481a96d48439c8e7df639aae449",
        // Set the channel name.
        channel: "class 3nov",
        // Pass your temp token here.
        token:
          "007eJxTYHhSK5vMv5Nv67/Nv467yHTxBTus2j1Xd9KRe4qNaTH9M/4qMKSam6QamVgYJlqapZhYmBhbJlukmqekmRlbJiammphYtkcnJTcEMjJsSwpiZmSAQBCfk6EktbikLDMlNZ+BAQAZ5yHg",
        token_share: "",
        // Set the user ID.
        uid: null,
        uid_share: null,
        username: null,
        eventName: null,
      },

      remoteUsers: {},
      remote_users_id: [],
      buttons_status: {
        is_join: false,
        is_video_muted: false,
        is_audio_muted: false,
      },
      users: [],
      all_users: {},
      is_share_screen: false,
      sharedUsers: [],
      display_user: false,
      local_user_name: null,
      local_user_char: null,
    };
  },
  watch: {
    // whenever question changes, this function will run
    remoteUsers(new_remoteUsers, old_remoteUsers) {
      console.log("in watch");
      console.log(new_remoteUsers);
      console.log(old_remoteUsers);
    },
  },
  beforeUpdate() {
    console.log(this.users);
  },
  updated() {
    console.log("in updated");
    console.log(this.remoteUsers);
    // let index = 0,
    //   no = this.users.length;
    // let rows_number = Math.floor(Math.sqrt(no)),
    //   cols_number = Math.ceil(no / rows_number),
    //   col_size = Math.floor(12 / cols_number),
    //   row_size = Math.round(12 / rows_number),
    //   grid_size = cols_number * col_size;

    // for (const user in this.users) {
    //   // console.log(`${user}: ${temp.remoteUsers[user]}`);

    //   let id = user;
    //   // console.log(id);
    //   let dom = document.querySelector("#user-" + id);
    //   // console.log(dom);
    //   // if (!dom) {
    //   //   dom = document.createElement("section");
    //   //   dom.setAttribute("id", "ag-item-" + id);
    //   //   dom.setAttribute("class", "ag-item");
    //   //   canvas.appendChild(dom);
    //   //   item.play("ag-item-" + id);
    //   // }

    //   $(".users-container").css(
    //     "grid-template-columns",
    //     "repeat(" + grid_size + ", 1fr)"
    //   );

    //   // if (grid_size != 12) {
    //   //   console.log("in grid size != 12 ");
    //   //   console.log($(".users-container"));
    //   //   let domC = document.querySelector(".users-container");
    //   //   // domC.setAttribute(
    //   //   //   "style",
    //   //   //   `grid-template-columns: repeat(${grid_size},1fr)`
    //   //   // );
    //   //   $(".users-container").css("background","red")

    //   // } else {
    //   //   $(".users-container").css(" grid-template-columns", " repeat(12, 1fr)");
    //   //   let domC = document.querySelector(".users-container");
    //   //   domC.setAttribute(
    //   //     "style",
    //   //     `grid-template-columns: repeat(${grid_size},1fr)`
    //   //   );
    //   // }
    //   console.log(
    //     no,
    //     rows_number,
    //     cols_number,
    //     col_size,
    //     12 / cols_number,
    //     grid_size
    //   );
    //   //"span 12/span 12/13/13"

    //   dom.setAttribute("style", `grid-area: span ${row_size}/span ${col_size}`);
    //   index++;
    // }
    // if (no == 2 || no == 3) {
    //   $(".users-container .user").css("height", "50%");
    // } else {
    //   $(".users-container .user").css("height", "100%");
    // }
    // let temp = this;
    this.redrawUsers();
    // setTimeout(function () {
    //   // console.log(temp.remoteUsers);

    // }, 8000);
    console.log(shareTrack);
    console.log(clientShare);
  },
  async mounted() {
    this.overlay_show = true;

    let tempId = this.generateRandom(1000, 2000);
    console.log("========", tempId);
    console.log(this.$route.params.booking_id);

    let loginedUser = JSON.parse(window.localStorage.getItem("user"));
    if (loginedUser.second_name != null) {
      this.options.uid =
        loginedUser.first_name +
        "_" +
        loginedUser.second_name +
        "_" +
        loginedUser.id;
      this.local_user_name =
        loginedUser.first_name + " " + loginedUser.second_name;
      this.local_user_char =
        loginedUser.first_name[0] + loginedUser.second_name[0];
    } else {
      this.options.uid =
        loginedUser.first_name +
        "_" +
        loginedUser.last_name +
        "_" +
        loginedUser.id;
      this.local_user_name =
        loginedUser.first_name + " " + loginedUser.last_name;
      this.local_user_char =
        loginedUser.first_name[0] + loginedUser.last_name[0];
    }
    // let  [id, username, userchars] = this.getUserNameAndId(this.options.uid)
    //   console.log(id, username, userchars)
    console.log("before get booking data");
    if (window.localStorage.getItem("customer") != null) {
      await this.getBookingData(this.$route.params.booking_id);
    } else {
      this.options.channel = this.$route.params.booking_id;
      this.options.eventName = this.$route.params.event_name;
      await this.getTokenOfEvent("video", this.options.uid);
    }
    console.log("after call get booking data and token");

    $("body").css("height", "100%");
    client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
    client.enableAudioVolumeIndicator();
    client.on("volume-indicator", (volumes) => {
      volumes.forEach((volume) => {
        // console.log(`UID ${volume.uid} Level ${volume.level}`);
        if (this.options.uid == volume.uid && volume.level > 5) {
          $("#local-player").css({
            "box-shadow": "0 2px 4px 5px #0C9DFD, 0 2px 5px 5px #0C9DFD",
          });
        } else if (this.options.uid == volume.uid && volume.level < 5) {
          $("#local-player").css({
            "box-shadow": "none",
          });
        }
        if (this.options.uid != volume.uid && volume.level > 5) {
          $("#player-" + volume.uid).css({
            "box-shadow": "0 2px 4px 5px #0C9DFD, 0 2px 5px 5px #0C9DFD",
          });
        } else if (this.options.uid != volume.uid && volume.level < 5) {
          $("#player-" + volume.uid).css({
            "box-shadow": "none",
          });
        }
      });
    });

    // share screen client
    clientShare = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

    // clientShare = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
  },
  methods: {
    async getBookingData(booking_id) {
      console.log("in get booking data", booking_id);
      axios
        .post(
          "event/meeting-id-by-booking",
          { booking_id: booking_id },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: "DY",
              Authorization:
                "Bearer " +
                JSON.parse(window.localStorage.getItem("user")).access_token,
            },
          }
        )
        .then((response) => {
          console.log(response);
          console.log(response.data);
          this.options.channel = response.data.channel_name;
          this.options.eventName = response.data.event_name;
          this.getTokenOfEvent("video", this.options.uid);
        });
    },
    async getTokenOfEvent(type, user_id) {
      console.log("in get token of call");
      console.log(this.options);
      axios
        .post(
          "chat/agora/generate-rtc-token",
          { uuid: user_id, channel_name: this.options.channel },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: "DY",
              Authorization:
                "Bearer " +
                JSON.parse(window.localStorage.getItem("user")).access_token,
            },
          }
        )
        .then((response) => {
          console.log(response);
          console.log(response.data);
          if (type == "video") {
            this.options.token = response.data.agora_token;
          } else if (type == "share") {
            this.options.token_share = response.data.agora_token;
            this.joinShareScreen();
          }
          this.overlay_show = false;
          // this.options.eventName = response.data.event_name
        });
    },
    clickAddUser() {
      this.users.push("user " + (this.users.length + 1));
    },
    clickDeleteUser() {
      this.users.pop();
    },
    checkIfShareScreens() {
      console.log("in check if share");
      this.sharedUsers = [];

      for (const user in this.remoteUsers) {
        console.log(user);
        let arr = user.split("_");
        let idShare = arr[arr.length - 1];
        if (idShare >= 10000 && idShare <= 11000) {
          this.sharedUsers.push(user);
        }
      }
      console.log(this.sharedUsers);
    },
    redrawUsers() {
      let temp = this;
      console.log("in redraw users");
      console.log(clientShare);
      console.log(shareTrack);
      // alert(this.checkIfShareScreens())
      // console.log(this.checkIfShareScreens());
      this.checkIfShareScreens();
      if (this.sharedUsers.length > 0) {
        this.is_share_screen = true;
        console.log("has share screen - local");

        let domL = document.querySelector("#local-user");
        // console.log(domL);
        // alert(tile_canvas[no][index])
        // domL.setAttribute("style", `grid-area: ${tile_canvas[no][index]}`);
        domL.setAttribute("style", "grid-area: span 4 /span 12");

        for (const user in temp.remoteUsers) {
          console.log(`${user}: ${temp.remoteUsers[user]}`);

          let [userid, username, userchars] = this.getUserNameAndId(user);
          console.log(userid, username, userchars);

          let dom = document.querySelector("#player-wrapper-" + userid);
          console.log(dom);

          if (dom == null && !(userid >= 10000 && userid <= 11000)) {
            //   dom = document.createElement("section");
            //   dom.setAttribute("id", "ag-item-" + id);
            //   dom.setAttribute("class", "ag-item");
            //   canvas.appendChild(dom);
            //   item.play("ag-item-" + id);

            console.log("rrrrrrrrrrrrrrr");
            console.log(user);
            console.log(temp.remoteUsers[user]);
            console.log(temp.remoteUsers[user]._audio_muted_);

            let userstatus = temp.remoteUsers[user];
            let isAudioMuted = userstatus._audio_muted_;

            const player = $(`
        <div id="player-wrapper-${userid}" class="user-tile remote-user-container">
          <div id="player-${userid}" class="player">
             <div class="player-sub-name"><span>${userchars}</span></div>
             <p class="player-name">${username} <span class="player-status"></span> </p></div>
        </div>
      `);
            $("#remote-playerlist").append(player);
            dom = document.querySelector("#player-wrapper-" + userid);
            if (isAudioMuted == true) {
              $("#player-" + userid + " .player-status").removeClass(
                "unmuted-audio"
              );
              $("#player-" + userid + " .player-status").addClass(
                "muted-audio"
              );

              $("#list-item-remote-" + userid + " .player-status").removeClass(
                "unmuted-audio"
              );
              $("#list-item-remote-" + userid + " .player-status").addClass(
                "muted-audio"
              );
            } else {
              $("#player-" + userid + " .player-status").removeClass(
                "muted-audio"
              );
              $("#player-" + userid + " .player-status").addClass(
                "unmuted-audio"
              );

              $("#list-item-remote-" + userid + " .player-status").removeClass(
                "muted-audio"
              );
              $("#list-item-remote-" + userid + " .player-status").addClass(
                "unmuted-audio"
              );
            }

            // $("#player-wrapper-" + id +" .player-status").addClass("unmuted-audio");
          }
          console.log(dom);
          // dom.setAttribute("style", `grid-area: ${tile_canvas[no][index + 1]}`);
          if (userid >= 10000 && userid <= 11000) {
            // dom.setAttribute("style", "grid-area: 1/1/ span 12/span 10");
          } else {
            dom.setAttribute("style", "grid-area: span 4/ span 12");
            //  dom.setAttribute(
            //   "style",
            //   `grid-area: span ${row_size}/span ${col_size}`
            // );
          }
          // index++;
        }
        return;
      } else {
        this.is_share_screen = false;
        let index = 0;
        let no = temp.remote_users_id.length + 1;
        let rows_number = Math.floor(Math.sqrt(no)),
          cols_number = Math.ceil(no / rows_number),
          col_size = Math.floor(12 / cols_number),
          row_size = Math.round(12 / rows_number),
          grid_size = cols_number * col_size;

        // let domS = document.querySelector("#share-screen-user");
        // // console.log(domL);
        // // alert(tile_canvas[no][index])
        // // domL.setAttribute("style", `grid-area: ${tile_canvas[no][index]}`);
        // domS.setAttribute(
        //   "style",
        //   'grid-area: span 12/span 12'
        // );

        let domL = document.querySelector("#local-user");
        // console.log(domL);
        // alert(tile_canvas[no][index])
        // domL.setAttribute("style", `grid-area: ${tile_canvas[no][index]}`);
        domL.setAttribute(
          "style",
          `grid-area: span ${row_size}/span ${col_size}`
        );

        for (const user in temp.remoteUsers) {
          console.log(`${user}: ${temp.remoteUsers[user]}`);

          let id = user;
          console.log(id);

          let [userid, username, userchars] = this.getUserNameAndId(id);
          console.log(userid, username, userchars);

          let dom = document.querySelector("#player-wrapper-" + userid);
          console.log(dom);
          if (dom == null) {
            //   dom = document.createElement("section");
            //   dom.setAttribute("id", "ag-item-" + id);
            //   dom.setAttribute("class", "ag-item");
            //   canvas.appendChild(dom);
            //   item.play("ag-item-" + id);
            console.log("xxxxxxxxxxxx");
            console.log(user);
            console.log(temp.remoteUsers[user]);
            console.log(temp.remoteUsers[user]._audio_muted_);

            let userstatus = temp.remoteUsers[user];
            let isAudioMuted = temp.remoteUsers[user]._audio_muted_;

            /**$("#local-player .player-status").addClass("unmuted-audio");

        $("#list-item-local-name").html(`${this.local_user_name}`);
        $("#list-item-local .player-status").addClass("unmuted-audio"); */
            const player = $(`
        <div id="player-wrapper-${userid}" class="user-tile remote-user-container">
          <div id="player-${userid}" class="player">
             <div class="player-sub-name"><span>${userchars}</span></div>
             <p class="player-name"> ${username} <span class="player-status"></span> </p></div>
        </div>
      `);
            $("#remote-playerlist").append(player);
            dom = document.querySelector("#player-wrapper-" + userid);
            if (isAudioMuted == true) {
              $("#player-" + userid + " .player-status").removeClass(
                "unmuted-audio"
              );
              $("#player-" + userid + " .player-status").addClass(
                "muted-audio"
              );

              $("#list-item-remote-" + userid + " .player-status").removeClass(
                "unmuted-audio"
              );
              $("#list-item-remote-" + userid + " .player-status").addClass(
                "muted-audio"
              );
            } else {
              $("#player-" + userid + " .player-status").removeClass(
                "muted-audio"
              );
              $("#player-" + userid + " .player-status").addClass(
                "unmuted-audio"
              );

              $("#list-item-remote-" + userid + " .player-status").removeClass(
                "muted-audio"
              );
              $("#list-item-remote-" + userid + " .player-status").addClass(
                "unmuted-audio"
              );
            }

            // $("#player-wrapper-" + id +" .player-status").addClass("unmuted-audio");
          }
          console.log(dom);
          // dom.setAttribute("style", `grid-area: ${tile_canvas[no][index + 1]}`);
          // if(id >= 10000 && id<=11000){
          //   dom.setAttribute(
          //     "style",
          //     'grid-area: span 12/span 11'
          //   );
          // }else{
          dom.setAttribute(
            "style",
            `grid-area: span ${row_size}/span ${col_size}`
          );
          // }
          index++;
        }
        if (no == 2 || no == 3) {
          $("#remote-playerlist .user-tile").css("height", "50%");
        } else {
          $("#remote-playerlist .user-tile").css("height", "100%");
        }
        // this.remoteUsers.map((item, index) => {
        //   console.log(index);
        //   console.log(item);
        // });
      }
    },

    async clickJoin() {
      console.log("click join");
      console.log(this.options);
      try {
        $("#join").attr("disabled", true);

        client.on("user-published", this.handleUserPublished);
        client.on("user-unpublished ", this.handleUserUnpublished);
        client.on("user-info-updated", this.handleUserInfoUpdated);

        client.on("user-joined", this.handleUserJoined);
        client.on("user-left", this.handleUserLeft);
        client.on("peer-online", function (evt) {
          console.log("peer online");
          console.log("peer-online", evt.uid);
        });

        //token
        client.on("token-privilege-will-expire", async function () {
          // After requesting a new token
          // await client.renewToken(token);
          alert("Sorry, token will expire in 30 seconds");
          await client.leave();
          this.$router.go();
        });
        client.on("token-privilege-did-expire", async () => {
          // After requesting a new token
          // await client.join(<APPID>, <CHANNEL NAME>, <NEW TOKEN>);
          alert("token is expired");
        });

        client.on("network-quality", this.displayNetworkQuality);

        // join a channel and create local tracks, we can use Promise.all to run them concurrently
        [this.options.uid, localTracks.audioTrack, localTracks.videoTrack] =
          await Promise.all([
            // join the channel
            client.join(
              this.options.appId,
              this.options.channel,
              this.options.token || null,
              this.options.uid || null
            ),
            // create local tracks, using microphone and camera
            AgoraRTC.createMicrophoneAudioTrack(),
            AgoraRTC.createCameraVideoTrack(),
          ]);

        client.on(
          "channel-media-relay-state",
          this.handleChannelMediaRelayState
        );
        client.on("connection-state-change", this.handleConnectionStateChange);
        client.on("stream-fallback", this.handleStreamFallback);

        this.showMuteButton();

        // play local video track
        localTracks.videoTrack.play("local-player");
        $("#local-player-name").html(
          `${this.local_user_name} <span class="player-status"></span>`
        );
        $("#local-player .player-status").addClass("unmuted-audio");

        $("#list-item-local-name").html(`${this.local_user_name}`);
        $("#list-item-local .player-status").addClass("unmuted-audio");

        // alert(localTrackState.videoTrackMuted +"  "+localTrackState.audioTrackMuted)

        // publish local tracks to channel
        await client.publish(Object.values(localTracks));
        console.log("publish success");
        $("#leave").attr("disabled", false);
        this.buttons_status.is_join = true;

        if (localTrackState.videoTrackMuted) {
          this.muteVideo();
        } else {
          this.unmuteVideo();
        }
        if (localTrackState.audioTrackMuted) {
          this.muteAudio();
        } else {
          this.unmuteAudio();
        }
      } catch (error) {
        console.error("in click join ");
        console.error(error);
      } finally {
        // $("#leave").attr("disabled", false);
        console.log("finally in join");
      }
    },
    clickShareScreen() {
      this.options.uid_share = "share_" + this.generateRandom();
      this.getTokenOfEvent("share", this.options.uid_share);
    },
    async joinShareScreen() {
      console.log(this.options.channel, this.options.token_share);
      await clientShare.join(
        this.options.appId,
        this.options.channel,
        this.options.token_share || null,
        this.options.uid_share
      );
      console.log("after join share");
      shareTrack = await AgoraRTC.createScreenVideoTrack();
      console.log("after create client share");
      await clientShare.publish(shareTrack);
      console.log("after publish share");

      Promise.all([clientShare, client]).then(() => {
        /** ... **/
      });
      console.log("after promise share");

      this.is_share_screen = true;

      shareTrack.on("track-ended", () => {
        console.log("stopScreenSharing");
        shareTrack.close();
        clientShare.leave();

        shareTrack = null;
        // clientShare = null;
        this.is_share_screen = false;
      });
      // shareTrack.play("share-screen-player");
    },
    async clickLeave() {
      for (let trackName in localTracks) {
        var track = localTracks[trackName];
        if (track) {
          track.stop();
          track.close();
          localTracks[trackName] = undefined;
        }
      }

      // remove remote users and player views
      this.remoteUsers = {};
      this.remote_users_id = [];
      // $("#remote-playerlist").html("");
      const elements = document.getElementsByClassName("remote-user-container");
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0]);
      }

      // leave the channel
      await client.leave();

      $("#local-player-name").text("");
      $("#list-item-local-name").text("");

      $("#join").attr("disabled", false);
      $("#leave").attr("disabled", true);
      $("#local-player").css({
        "box-shadow": "none",
      });

      this.buttons_status.is_join = false;
      this.display_user = false;

      this.hideMuteButton();
      console.log("client leaves channel success");
    },
    async clickMuteAudio() {
      console.log("in click mute audio", localTrackState.audioTrackMuted);
      if (!localTrackState.audioTrackMuted) {
        this.muteAudio();
      } else {
        this.unmuteAudio();
      }
    },
    async clickMuteVideo() {
      if (!localTrackState.videoTrackMuted) {
        this.muteVideo();
      } else {
        this.unmuteVideo();
      }
    },
    async subscribe(user, mediaType) {
      const uid = user.uid;
      // subscribe to a remote user
      await client.subscribe(user, mediaType);
      console.log("---------------------------");
      console.log("subscribe success", user.uid);
      console.log(user);
      console.log(user.videoTrack);
      console.log(user.audioTrack);

      // if the video wrapper element is not exist, create it.
      if (mediaType === "video") {
        let [userid, username, userchars] = this.getUserNameAndId(uid);
        console.log(userid, username, userchars);
        // alert("718 "+uid + " " + userid + " " + userid >= 10000 && userid <= 11000);
        if (userid >= 10000 && userid <= 11000) {
          $("#share-player-name").html(
            `share (${userid}) <span class="player-status"></span>`
          );
          $("#share-player .player-status").addClass("unmuted-audio");
          user.videoTrack.play("share-player");
        } else {
          if ($(`#player-wrapper-${userid}`).length === 0) {
            const player = $(`
        <div id="player-wrapper-${userid}" class="user-tile remote-user-container">
          <div id="player-${userid}" class="player">
             <p class="player-name">${username} <span class="player-status"></span> </p></div>
        </div>
      `);
            $("#remote-playerlist").append(player);
          }

          // play the remote video.
          user.videoTrack.play(`player-${userid}`);
        }
      }
      if (mediaType === "audio") {
        user.audioTrack.play();
      }
      console.log(this.remoteUsers);
    },

    handleUserJoined(user) {
      const id = user.uid;
      console.log("---------------------------");
      console.log("handle user join", user.uid);
      this.remoteUsers[id] = user;
      this.remote_users_id.push(id);
    },

    handleUserLeft(user) {
      const id = user.uid;
      console.log("---------------------------");
      console.log("handle user left", user.uid);
      delete this.remoteUsers[id];
      this.remote_users_id = this.remote_users_id.filter(function (item) {
        return item !== id;
      });

      let [userid, username, userchars] = this.getUserNameAndId(id);
      console.log(userid, username, userchars);

      $(`#player-wrapper-${userid}`).remove();
      console.log(client.getListeners("user-published"));
      console.log(client.getListeners("user-joined"));

      console.log(this.remoteUsers);
    },

    handleUserPublished(user, mediaType) {
      console.log("---------------------------");
      console.log("handle user publish", user.uid);
      this.subscribe(user, mediaType);
    },
    handleUserUnpublished(user, mediaType) {
      console.log("---------------------------");
      console.log("handle user unpublish", user.uid, mediaType);
    },
    handleUserInfoUpdated(user, msg) {
      console.log("---------------------------");
      console.log("handle user info updated", user);
      console.log("user info updated", msg, user);
      let user_obj = this.remoteUsers[user];
      console.log(this.remoteUsers);
      console.log(user_obj);
      console.log(user_obj._video_muted_);

      if (msg == "mute-video") {
        console.log("mute video");
        user_obj._video_muted_ = true;
        user_obj.video_muted = true;
        console.log(user_obj);
      } else if (msg == "unmute-video") {
        console.log("unmute video");
        user_obj._video_muted_ = false;
        user_obj.video_muted = false;
        console.log(user_obj);
      }
      this.remoteUsers[user] = user_obj;
      console.log(this.remoteUsers);
      // this.remoteUsers = Object.assign({}, this.remoteUsers);

      let [userid, username, userchars] = this.getUserNameAndId(user);
      console.log(userid, username, userchars);

      if (msg == "mute-audio") {
        $("#player-" + userid + " .player-status").removeClass("unmuted-audio");
        $("#player-" + userid + " .player-status").addClass("muted-audio");

        $("#list-item-remote-" + userid + " .player-status").removeClass(
          "unmuted-audio"
        );
        $("#list-item-remote-" + userid + " .player-status").addClass(
          "muted-audio"
        );
      } else if (msg == "unmute-audio") {
        $("#player-" + userid + " .player-status").removeClass("muted-audio");
        $("#player-" + userid + " .player-status").addClass("unmuted-audio");

        $("#list-item-remote-" + userid + " .player-status").removeClass(
          "muted-audio"
        );
        $("#list-item-remote-" + userid + " .player-status").addClass(
          "unmuted-audio"
        );
      }
    },

    hideMuteButton() {
      $("#mute-video").css("display", "none");
      $("#mute-audio").css("display", "none");
    },

    showMuteButton() {
      $("#mute-video").css("display", "inline-block");
      $("#mute-audio").css("display", "inline-block");
    },
    async muteAudio() {
      console.log(
        "in mute audio ",
        this.buttons_status.is_join,
        localTracks.audioTrack
      );
      if (this.buttons_status.is_join && !localTracks.audioTrack) return;
      /**
       * After calling setMuted to mute an audio or video track, the SDK stops sending the audio or video stream. Users whose tracks are muted are not counted as users sending streams.
       * Calling setEnabled to disable a track, the SDK stops audio or video capture
       */
      console.log("in mute audio ");
      if (this.buttons_status.is_join == true) {
        await localTracks.audioTrack.setMuted(true);
      }
      console.log("in mute audio ");
      localTrackState.audioTrackMuted = true;
      $("#mute-audio").text("Unmute Audio");
      this.buttons_status.is_audio_muted = true;

      $("#local-player .player-status").removeClass("unmuted-audio");
      $("#local-player .player-status").addClass("muted-audio");

      $("#list-item-local .player-status").removeClass("unmuted-audio");
      $("#list-item-local .player-status").addClass("muted-audio");

      console.log(this.remoteUsers);
    },

    async muteVideo() {
      if (this.buttons_status.is_join && !localTracks.videoTrack) return;
      if (this.buttons_status.is_join == true) {
        await localTracks.videoTrack.setEnabled(false);
      }
      localTrackState.videoTrackMuted = true;
      $("#mute-video").text("Unmute Video");
      this.buttons_status.is_video_muted = true;
      console.log(this.remoteUsers);
      $("#local-player > p + div").css("position", "inherit");
      $("#local-player > p + div video").css("display", "none");
    },

    async unmuteAudio() {
      if (this.buttons_status.is_join && !localTracks.audioTrack) return;
      if (this.buttons_status.is_join == true) {
        await localTracks.audioTrack.setMuted(false);
      }
      localTrackState.audioTrackMuted = false;
      $("#mute-audio").text("Mute Audio");
      this.buttons_status.is_audio_muted = false;
      $("#local-player .player-status").removeClass("muted-audio");
      $("#local-player .player-status").addClass("unmuted-audio");

      $("#list-item-local .player-status").removeClass("muted-audio");
      $("#list-item-local .player-status").addClass("unmuted-audio");

      console.log(this.remoteUsers);
    },

    async unmuteVideo() {
      if (this.buttons_status.is_join && !localTracks.videoTrack) return;
      if (this.buttons_status.is_join == true) {
        await localTracks.videoTrack.setEnabled(true);
      }
      localTrackState.videoTrackMuted = false;
      $("#mute-video").text("Mute Video");
      this.buttons_status.is_video_muted = false;
      console.log(this.remoteUsers);
      $("#local-player > p + div").css("position", "relative");
      $("#local-player > p + div video").css("display", "block");
    },
    displayNetworkQuality(quality) {
      // console.log("network quality", quality);
      // console.log("uplinkNetworkQuality:", quality.uplinkNetworkQuality);
      // console.log("downlinkNetworkQuality:", quality.downlinkNetworkQuality);
    },
    handleConnectionStateChange(curState, revState, reason) {
      console.log("in handle connection on state change");
      console.log(curState);
      console.log(revState);
      console.log(reason);
    },
    handleChannelMediaRelayState(state, code) {
      console.log("in handle channel media relay state");
      console.log(state);
      console.log(code);
    },
    handleStreamFallback(uid, isFallbackOrRecover) {
      console.log("in handle stream fallback", uid, isFallbackOrRecover);
    },
    generateRandom(min = 10000, max = 11000) {
      console.log("Generate random", min, max);
      // find diff
      let difference = max - min;

      // generate random number
      let rand = Math.random();

      // multiply with difference
      rand = Math.floor(rand * difference);

      // add with min value
      rand = rand + min;

      return rand;
    },
    getUserNameAndId(uid) {
      let temp = uid.split("_");
      let id = temp[temp.length - 1];
      let username = temp[0],
        userchars = temp[0][0];
      for (let i = 1; i < temp.length - 1; i++) {
        username += " " + temp[i];
        if (userchars.length < 2) {
          userchars += temp[i][0];
        }
      }
      return [id, username, userchars];
    },
  },
};
</script>
<style>
@import "../../assets/css/agora-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/Agora/Index.vue